import { Box, Fade } from '@mui/material';
import React from 'react';
import IncPageLoader from './inc-page-loader/inc-page-loader.component';
import IncPageProvider from './inc-page.context';
import IncPageBreadcrumbs from './inc-page-breadcrumbs/inc-page-breadcrumbs.component';

export type IncPageProps = {
  children: React.ReactNode;
  'data-testid'?: string;
  loadingState?: {
    isLoading: boolean;
    isFetching: boolean;
    isUninitialized: boolean;
  };
  overlay?: string[];
};

const IncPage = React.forwardRef(
  (
    {
      children,
      'data-testid': dataTestId = 'IncPage',
      loadingState,
      overlay,
      ...rest
    }: IncPageProps,
    ref,
  ) => {
    return (
      <Fade in={true}>
        <Box
          data-testid={dataTestId}
          display="flex"
          flexDirection="column"
          flexGrow={1}
          position="relative"
          ref={ref}
          {...rest}
        >
          <IncPageLoader loadingState={loadingState} overlay={overlay} />
          <Box p={2} display="flex" flexDirection="column" flexGrow={1}>
            <IncPageProvider>
              <IncPageBreadcrumbs />
              {children}
            </IncPageProvider>
          </Box>
        </Box>
      </Fade>
    );
  },
);
export default IncPage;
